/* Mixed-cart recovery. Owns only the cart-mode gate, never delivery/pickup gates. */
(function () {
  'use strict';
  if (window.HMD_CART_MODE_READY) return;
  window.HMD_CART_MODE_READY = true;
  window.HMD_EXPLICIT_CART_MODE = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart, busy = false, checking, error = '', fingerprint = '', allowClick = false;
  var panel, deliveryNotice, state = 'checking', lastTelemetry = '', allowSubmit = false;
  var selectors = '#checkout,button[name="checkout"],input[name="checkout"],a[href$="/checkout"]';
  var productCache = {};

  async function json(path, options) {
    var response = await fetch(root + path, Object.assign({ cache: 'no-store' }, options));
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed. Please try again.');
    return data;
  }
  function items(c) {
    if (!c || !Array.isArray(c.items)) throw new Error('We could not verify your cart. Please try again.');
    return c.items;
  }
  function mixed(c) {
    return items(c).some(function (i) { return !!i.selling_plan_allocation; }) &&
      items(c).some(function (i) { return !i.selling_plan_allocation; });
  }
  function deliveryIssue() {
    if (!cart || !Array.isArray(cart.items)) return 'Please wait while we verify your cart.';
    if (!cart.items.some(function (i) { return !i.gift_card && i.requires_shipping !== false; })) return '';
    try {
      if (!/^\d{5}$/.test(localStorage.getItem('hmd_zip') || '')) {
        return 'Enter and check your ZIP code in Delivery Options before continuing to checkout.';
      }
      var method = JSON.parse(localStorage.getItem('hmd_method') || 'null');
      var expected = { pickup: 'Store Pickup', local_delivery: 'Local Delivery', shipping: 'Shipping' };
      if (!method || !expected[method.type] || (cart.attributes || {})['Type Of Order'] !== expected[method.type]) {
        return 'Confirm your delivery or pickup option above before continuing to checkout.';
      }
    } catch (_) { return 'Enter and check your ZIP code in Delivery Options before continuing to checkout.'; }
    return '';
  }
  function showDeliveryIssue() {
    if (!deliveryNotice) return;
    deliveryNotice.hidden = false;
    deliveryNotice.focus();
    deliveryNotice.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function telemetry() {
    var api = window.__hmdCheckoutTelemetry;
    if (!api) return;
    var reason = busy ? 'cart_mode_conversion_pending' :
      state === 'mixed' ? 'mixed_cart' : state === 'error' ? 'cart_mode_verification_failed' :
      deliveryIssue() ? 'zip_or_delivery_confirmation_required' : '';
    if (reason === lastTelemetry) return;
    lastTelemetry = reason;
    if (reason) api.block(reason, 'cart_mode', { owner: 'cart_mode', explicit: true, source: 'cart_mode_recovery' });
    else api.unblock('cart_mode', 'cart_mode_verified', 'cart_mode', { source: 'cart_mode_recovery' });
  }
  function element(tag, text) {
    var el = document.createElement(tag);
    if (text) el.textContent = text;
    return el;
  }
  function button(text, action) {
    var el = element('button', text);
    el.type = 'button';
    el.disabled = busy;
    el.addEventListener('click', action);
    return el;
  }
  function render() {
    var checkout = document.querySelector('#checkout');
    if (!checkout) return;
    if (!panel || !panel.isConnected) {
      panel = element('section');
      panel.id = 'hmd-cart-mode';
      panel.tabIndex = -1;
      panel.setAttribute('aria-label', 'Cart purchase options');
      checkout.parentNode.insertBefore(panel, checkout);
      fingerprint = '';
    }
    if (!deliveryNotice || !deliveryNotice.isConnected) {
      deliveryNotice = element('section');
      deliveryNotice.id = 'hmd-cart-delivery-required';
      deliveryNotice.tabIndex = -1;
      deliveryNotice.setAttribute('role', 'status');
      checkout.parentNode.insertBefore(deliveryNotice, checkout);
    }
    var issue = deliveryIssue();
    deliveryNotice.hidden = !issue;
    deliveryNotice.textContent = issue;
    document.querySelectorAll(selectors).forEach(function (b) {
      // Never clear disabled, aria-disabled or styles owned by another checkout gate.
      b.classList.toggle('hmd-mode-blocked', state !== 'ready' || busy || !!issue);
    });
    panel.hidden = state === 'ready' && !error && !busy;
    telemetry();
    var signature = JSON.stringify([cart, state, busy, error]);
    if (signature === fingerprint) return;
    fingerprint = signature;
    panel.replaceChildren();
    panel.appendChild(element('h3', state === 'mixed' ? 'Choose one purchase option for your cart' : 'Checking your cart'));
    var status = element('p', busy ? 'Updating your items. Please keep this page open.' :
      error || (state === 'mixed' ? 'Subscription and one-time items cannot check out together. Choose how you want to purchase all items.' : 'Verifying your purchase options…'));
    status.setAttribute('role', error ? 'alert' : 'status');
    panel.appendChild(status);
    if (cart && (state === 'mixed' || error || busy)) {
      ['Subscription items', 'One-time items'].forEach(function (label, index) {
        var group = items(cart).filter(function (i) { return !!i.selling_plan_allocation === (index === 0); });
        if (!group.length) return;
        panel.appendChild(element('h4', label));
        var list = element('ul');
        group.forEach(function (i) {
          var plan = i.selling_plan_allocation;
          list.appendChild(element('li', i.quantity + ' × ' + (i.product_title || i.title) +
            (i.variant_title && i.variant_title !== 'Default Title' ? ' — ' + i.variant_title : '') +
            (plan ? ' — ' + plan.selling_plan.name : ' — One-time purchase')));
        });
        panel.appendChild(list);
      });
      var label = element('label', 'Subscription frequency ');
      var select = element('select');
      select.id = 'hmd-cart-mode-frequency';
      select.disabled = busy;
      [['weekly', 'Weekly'], ['biweekly', 'Every 2 weeks'], ['monthly', 'Every 4 weeks']].forEach(function (entry) {
        var option = element('option', entry[1]); option.value = entry[0]; select.appendChild(option);
      });
      var existing = items(cart).find(function (i) { return i.selling_plan_allocation; });
      if (existing) select.value = frequency(existing.selling_plan_allocation.selling_plan) || 'weekly';
      label.appendChild(select);
      panel.appendChild(label);
      var actions = element('div');
      actions.className = 'hmd-mode-actions';
      actions.appendChild(button('Make all subscription', function () { convert(select.value); }));
      actions.appendChild(button('Make all one-time', function () { convert('onetime'); }));
      panel.appendChild(actions);
      panel.appendChild(element('p', 'Prices and discounts will be recalculated. Delivery eligibility, pickup location and minimum-order checks still apply. Items that do not support your choice must be removed or replaced.'));
    }
    if (error) panel.appendChild(button('Recheck cart', function () { error = ''; refresh(); }));
  }
  function frequency(plan) {
    var name = (plan.name || '').toLowerCase();
    if (/biweekly|bi-weekly|every 2 week|every two week|14 day/.test(name)) return 'biweekly';
    if (/monthly|every 4 week|every four week|28 day/.test(name)) return 'monthly';
    if (/weekly|every week|every 1 week|7 day/.test(name)) return 'weekly';
    return '';
  }
  async function refresh() {
    if (busy) return;
    if (checking) return checking;
    checking = (async function () {
      try {
        cart = await json('cart.js');
        state = mixed(cart) ? 'mixed' : 'ready';
      } catch (e) { state = 'error'; error = e.message; }
      finally { checking = null; render(); }
    })();
    return checking;
  }
  async function choice(item, mode) {
    if (!item.handle) throw new Error('Cannot verify purchase options for ' + item.title + '. Please remove or replace this item.');
    var product = await (productCache[item.handle] || (productCache[item.handle] =
      json('products/' + encodeURIComponent(item.handle) + '.js').catch(function (e) { delete productCache[item.handle]; throw e; })));
    var variant = (product.variants || []).find(function (v) { return String(v.id) === String(item.variant_id); });
    if (!variant) throw new Error('This variant is no longer available: ' + item.title);
    if (mode === 'onetime') {
      if (product.requires_selling_plan || variant.requires_selling_plan) throw new Error(item.title + ' is subscription-only. Remove or replace it to make this an all one-time cart.');
      return null;
    }
    var plans = (product.selling_plan_groups || []).flatMap(function (g) { return g.selling_plans || []; });
    var allowed = (variant.selling_plan_allocations || []).map(function (a) { return String(a.selling_plan_id); });
    var plan = plans.find(function (p) { return allowed.includes(String(p.id)) && frequency(p) === mode; });
    if (!plan) throw new Error(item.title + ' does not offer that subscription frequency. Choose another frequency or make all items one-time.');
    return plan.id;
  }
  function quantities(c) {
    var result = {};
    items(c).forEach(function (i) {
      var properties = Object.entries(i.properties || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); });
      var key = JSON.stringify([String(i.variant_id), properties]);
      result[key] = (result[key] || 0) + i.quantity;
    });
    return JSON.stringify(Object.entries(result).sort());
  }
  async function convert(mode) {
    if (busy) return;
    if (checking) await checking;
    if (busy) return;
    busy = true; window.HMD_CART_MODE_BUSY = true; error = ''; render();
    try {
      cart = await json('cart.js');
      var original = quantities(cart);
      // Preflight every item before any writes, including variant-specific eligibility.
      var planned = await Promise.all(items(cart).map(async function (i) { return { key: i.key, plan: await choice(i, mode) }; }));
      for (var target of planned) {
        var fresh = await json('cart.js');
        if (quantities(fresh) !== original) throw new Error('Your cart changed during the update. Review it and try again.');
        var line = items(fresh).find(function (i) { return i.key === target.key; });
        // Shopify can merge equal lines after changing a plan; final verification covers them.
        if (!line) continue;
        var current = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id;
        if (String(current || '') === String(target.plan || '')) continue;
        await json('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: target.plan }) });
      }
      cart = await json('cart.js');
      if (quantities(cart) !== original || !items(cart).every(function (i) {
        return mode === 'onetime' ? !i.selling_plan_allocation :
          !!i.selling_plan_allocation && frequency(i.selling_plan_allocation.selling_plan) === mode;
      })) throw new Error('Some items could not be verified. Review the list and retry your choice; checkout remains protected.');
      state = 'ready';
      telemetry();
      // Re-render all Shopify totals and re-run existing delivery, pickup and minimum gates.
      window.location.reload();
    } catch (e) {
      error = e.message + ' Any completed item changes have been kept; no items were removed.';
      try { cart = await json('cart.js'); state = mixed(cart) ? 'mixed' : 'error'; } catch (_) { state = 'error'; }
    } finally {
      busy = false; window.HMD_CART_MODE_BUSY = false; render();
    }
  }
  // Recheck immediately before checkout, then let the existing checkout handlers run.
  window.addEventListener('click', async function (event) {
    var target = event.target.closest && event.target.closest(selectors);
    if (!target || allowClick) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!busy) await refresh();
    if (state !== 'ready' || busy) { if (panel) panel.focus(); return; }
    if (deliveryIssue()) { showDeliveryIssue(); return; }
    allowClick = true;
    try { target.click(); } finally { allowClick = false; }
  }, true);
  window.addEventListener('submit', async function (event) {
    if (!event.target.matches('form[action$="/cart"]') || !event.submitter || !event.submitter.matches(selectors)) return;
    if (allowSubmit) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var form = event.target, submitter = event.submitter;
    if (!busy) await refresh();
    if (state !== 'ready' || busy) { if (panel) panel.focus(); return; }
    if (deliveryIssue()) { showDeliveryIssue(); return; }
    allowSubmit = true;
    try { form.requestSubmit(submitter); } finally { allowSubmit = false; }
  }, true);
  ['cart:refresh', 'cart:updated', 'sections:rendered'].forEach(function (name) { document.addEventListener(name, refresh); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  setInterval(function () { if (!document.hidden) refresh(); }, 5000);
  refresh();
})();
